import {useLocation} from 'react-router-dom';
import {IS_DASHBOARD_MODE} from 'utils/consts';

const pathTitles = {
  audit_rules: 'TRACK - Audit Rules',
  audits_issue_overview: 'TRACK - Audit Issue Overview',
  audits_overview: 'TRACK - Audit Overview',
  audits_school_summary: 'TRACK - Audits School Summary',
  audits: 'TRACK - Audits Table',
  data_portal: 'TRACK - Data Portal',
  data_report: 'TRACK - Data Reports',
  esoy_it_support: 'TRACK - E/SOY IT Support',
  hs_schedule: 'TRACK - High School Scheduling',
  person: 'TRACK - User Management',
  school_setup: 'TRACK - E/SOY',
  search: 'TRACK - Search',
  search_chat: 'TRACK - Search Chat',
  staff_roles: 'TRACK - Staff Roles',
  staff_roles_it_support: 'TRACK - Staff Roles IT Support',
  source_manager: 'TRACK - Source Manager',
  tags_categories: 'TRACK - Tags & Categories',
};

// if the path contains a school abbreviation, we want to include that in the title.
// this is relevant for pages like /audits/:school and /hs_schedule/:school
const schoolPathTitles = [
  'audits_school_summary',
  'audits',
  'hs_schedule',
  'school_setup',
  'staff_roles',
];

const Title = ({children}) => {
  const location = useLocation();

  let title = 'TRACK';
  const path = location.pathname.split('/')[1];

  if (children) {
    title = children;
  } else if (IS_DASHBOARD_MODE) {
    title = 'Uncommon Dashboards';
  } else if (pathTitles[path]) {
    title = pathTitles[path];
  } else {
    title = 'TRACK';
  }

  if (schoolPathTitles.includes(path)) {
    const schoolAbbr = location.pathname.split('/')[2];
    if (schoolAbbr && !schoolAbbr.includes('editor') && schoolAbbr !== 'new') {
      title += ` - ${schoolAbbr.toUpperCase()}`;
    }
  }
  document.title = title;

  return null;
};

export default Title;
